import React, { createContext, useContext } from "react";

const FilterContext = createContext(null);

export function useFilter() {
    return useContext(FilterContext) || 'ALL';
}

export default function FilterProvider(props) {
    return (
        <FilterContext.Provider value={props.filter}>
            {props.children}
        </FilterContext.Provider>
    );
}
